import { render, staticRenderFns } from "./dateSelect.vue?vue&type=template&id=2a820295&scoped=true&"
import script from "./dateSelect.vue?vue&type=script&lang=js&"
export * from "./dateSelect.vue?vue&type=script&lang=js&"
import style0 from "./dateSelect.vue?vue&type=style&index=0&id=2a820295&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a820295",
  null
  
)

export default component.exports